// Coverage line label maps — FE-SCRM-015.
//
// Single source of truth for the human copy attached to each enum
// value. The Panel + modals read these instead of building inline
// look-ups so the user-facing wording stays consistent.

import type {
  CoverageLineOutcome,
  CoverageLineType,
  QuoteStatus,
} from "./types";


export const COVERAGE_LINE_TYPE_LABEL: Record<CoverageLineType, string> = {
  medical: "Medical",
  dental: "Dental",
  vision: "Vision",
  life: "Life",
  std: "Short-term disability",
  ltd: "Long-term disability",
  voluntary: "Voluntary",
  eap: "EAP",
  other: "Other",
};


export const QUOTE_STATUS_LABEL: Record<QuoteStatus, string> = {
  not_started: "Not started",
  rfp_sent: "RFP sent",
  proposals_received: "Proposals received",
  presented: "Presented",
  decided: "Decided",
};


export const COVERAGE_LINE_OUTCOME_LABEL: Record<CoverageLineOutcome, string> = {
  pending: "Pending",
  won: "Won",
  lost: "Lost",
  not_pursued: "Not pursued",
};


/** Tailwind class strings for the outcome chip. ``pending`` is muted
 * neutral; ``won`` uses the project's success token; ``lost`` uses the
 * critical token; ``not_pursued`` keeps the neutral tone so it doesn't
 * scream — producers who explicitly opt out of a line shouldn't feel
 * penalised by the visual treatment. */
export const COVERAGE_LINE_OUTCOME_TONE: Record<
  CoverageLineOutcome, "neutral" | "success" | "critical" | "muted"
> = {
  pending: "neutral",
  won: "success",
  lost: "critical",
  not_pursued: "muted",
};


/** Format a cents-denominated bigint as a USD string. ``null`` stays
 * ``null`` so the caller can render a dash for the empty case. */
export function formatPremium(cents: number | null): string | null {
  if (cents === null || cents === undefined) return null;
  const dollars = cents / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(dollars);
}
